var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'locale-'+_vm.$i18n.locale,attrs:{"id":"app"}},[_c('loading',{attrs:{"open":!_vm.DOMloaded,"refresh":_vm.refresh,"label":_vm.loadingLabel,"error":"false"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }